// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__21BwT","versionOneContent":"styles_versionOneContent__DOE6x"};